import type { RootState } from "single-spa/store/types";

export const selectToasts = (state: RootState) => state.ui.toasts;
